export default [
  {
    path: "/onthejobtraining",
    name: "onthejobtraining",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "onthejobtraining.Baslik",
      yetki: { k: [2000102] },
    },
  },
  {
    path: "/onthejobtraining/form/:uuid",
    name: "onthejobtraining-form",
    component: () => import("./form.vue"),
    meta: {
      public: false,
      title: "onthejobtraining.Baslik",
      yetki: { k: [2000102] },
    },
  },
]
